let cachedPublicKey = null;

async function fetchPublicKey() {
  if (cachedPublicKey) return cachedPublicKey;
  const res = await fetch(
    `${process.env.REACT_APP_AUTH_API_URL}/auth/public/encryption-key`
  );
  const data = await res.json();
  const pem = data.publicKey;
  const b64 = pem
    .replace("-----BEGIN PUBLIC KEY-----", "")
    .replace("-----END PUBLIC KEY-----", "")
    .replace(/\n/g, "");
  const binary = Uint8Array.from(atob(b64), (c) => c.charCodeAt(0));
  cachedPublicKey = await crypto.subtle.importKey(
    "spki",
    binary,
    { name: "RSA-OAEP", hash: "SHA-256" },
    false,
    ["encrypt"]
  );
  return cachedPublicKey;
}

export async function encryptPassword(password) {
  const publicKey = await fetchPublicKey();
  const payload = `${password}:${Math.floor(Date.now() / 1000)}`;
  const encoded = new TextEncoder().encode(payload);
  const encrypted = await crypto.subtle.encrypt(
    { name: "RSA-OAEP" },
    publicKey,
    encoded
  );
  return btoa(String.fromCharCode(...new Uint8Array(encrypted)));
}
